import { CssBaseline, GlobalStyles, ThemeProvider } from "@mui/material";
import { useMemo } from "react";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { ColorModeProvider, useColorMode } from "./context/ColorModeContext";
import { CompanyBlocksProvider } from "./context/CompanyBlocksContext";
import Routes from "./routes/Routes";
import { createAppTheme } from "./utils/theme/theme";

function ThemedApp() {
  const { mode } = useColorMode();
  const theme = useMemo(() => createAppTheme(mode), [mode]);

  const bgColor = mode === "light" ? "#f2f3f7" : "#111318";
  const dotColor = mode === "light" ? "rgba(0,0,0,0.10)" : "rgba(255,255,255,0.06)";

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <GlobalStyles
        styles={{
          "html, body, #root": { minHeight: "100vh" },
          body: {
            backgroundColor: bgColor,
            backgroundImage: `radial-gradient(circle, ${dotColor} 1px, transparent 1px)`,
            backgroundSize: "20px 20px",
          },
        }}
      />
      <BrowserRouter>
        <AuthProvider>
          <CompanyBlocksProvider>
            <Routes />
          </CompanyBlocksProvider>
        </AuthProvider>
      </BrowserRouter>
    </ThemeProvider>
  );
}

function App() {
  return (
    <ColorModeProvider>
      <ThemedApp />
    </ColorModeProvider>
  );
}

export default App;
